import { render, staticRenderFns } from "./InternalError.vue?vue&type=template&id=4c59fd45&scoped=true&"
import script from "./InternalError.vue?vue&type=script&lang=ts&"
export * from "./InternalError.vue?vue&type=script&lang=ts&"
import style0 from "./InternalError.vue?vue&type=style&index=0&id=4c59fd45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c59fd45",
  null
  
)

export default component.exports